import React, { useEffect, useRef } from 'react';
import useCartState from './useCartState';
import useProductPrice from './useProductPrice';
import { setCartDataAnalytics } from '../metrics/track-params';
import useTrackCustomMetric from './useTrackCustomMetric';
import { priceWasFetched } from '../metrics/metrics-helpers';
import { usePageViewTriggered } from './usePageView';
import { useTemplateKey } from './usePageComponents';
import { Helpers } from '../core/src/helpers';

let cartReadyTriggered;
let cartPageReadyTriggered;

const pickCouponCode = cartDetails => {
    const { applyCouponMessages } = cartDetails || {};
    const { orderLevel, itemLevel } = (applyCouponMessages || []).reduce(
        (r, code) => {
            const { type, orderItemId, promocode } = code || {};
            if (type === 'success') {
                if (orderItemId) {
                    r.itemLevel[orderItemId] = r.itemLevel[orderItemId]
                        ? r.itemLevel[orderItemId] + ',' + promocode
                        : promocode;
                } else {
                    r.orderLevel.push(promocode);
                }
            }
            return r;
        },
        { orderLevel: [], itemLevel: {} },
    );

    return { orderLevel: orderLevel.join(','), itemLevel };
};

const mapCartItems = (orderItem, orderitemIds) => {
    return orderItem.reduce((r, i, idx) => {
        const { priceData, invData } = (orderitemIds || {})[i.orderItemId] || {};
        let price = {};
        if (priceData && priceData.oPrice) {
            try {
                const qty = invData?.cartQty * 1 || 1;
                const offerPricePerUnit = Helpers.convertPriceToNumber(priceData.oPrice) / qty;
                const regularPricePerUnit = Helpers.convertPriceToNumber(priceData.gsPrice || priceData.oPrice) / qty;
                const discountAmount = regularPricePerUnit - offerPricePerUnit;

                price = {
                    price: offerPricePerUnit.toString(),
                    discountAmount,
                };
            } catch (e) {}
        }
        r[i.orderItemId] = {
            position: idx + 1,
            ...price,
        };
        return r;
    }, {});
};

export default () => {
    const trackCustomMetric = useTrackCustomMetric();
    const pageViewTriggered = usePageViewTriggered();
    const { cartInfo, cartId } = useCartState();
    const { cartDetails, tAdj, cartView } = cartInfo || {};
    const { items } = cartInfo || {};
    const { orderItem } = cartView || {};
    const { orderitemIds } = cartDetails || {};
    const templateKey = useTemplateKey();
    const { orderLevel: orderLevelPromo, itemLevel: itemLevelPromo } = pickCouponCode(cartDetails);
    let cartItemKeys = '';
    const isCartPage = templateKey === 'cart';
    const products =
        Array.isArray(items) &&
        items.reduce((allProducts, item) => {
            const { ceId, qty, pNum } = item || {};
            if (ceId && ceId.length > 0) {
                cartItemKeys += `-${pNum}-${qty}-`;
                allProducts.push({
                    sku: pNum,
                    catentryId: ceId,
                });
            }
            return allProducts;
        }, []);
    const { prices } = useProductPrice(products);
    const priceSkuKeys = prices && Object.keys(prices).join('-');
    //wait for cart products, unless it's the cart page then also wait for cart details
    const cartDataReady =
        Array.isArray(products) &&
        products.every(prd => {
            let { sku, catentryId } = prd || {};
            let fetched = priceWasFetched(prices, sku, catentryId);
            return fetched;
        }) &&
        (templateKey !== 'cart' || !!cartDetails);
    //if it's cart page, set the item position as they are displayed on cart
    const itemPosition = isCartPage && orderItem?.length > 0 ? mapCartItems(orderItem, orderitemIds) : undefined;
    useEffect(() => {
        try {
            setCartDataAnalytics(cartInfo, cartId, prices, orderLevelPromo, itemLevelPromo, itemPosition);
            if (
                (!cartReadyTriggered || (!cartPageReadyTriggered && isCartPage)) &&
                cartDataReady &&
                cartId &&
                pageViewTriggered
            ) {
                trackCustomMetric('cartProductsReady');
                cartReadyTriggered = true;
                isCartPage && (cartPageReadyTriggered = true);
            }
        } catch (e) {}
    }, [cartItemKeys, cartId, priceSkuKeys, cartDataReady, pageViewTriggered, orderLevelPromo, itemLevelPromo, tAdj]);
};
